<template>
    <nav :class="['nav-mobile', { 'nav-mobile--opened': isOpen }]">
        <a href="#" class="nav-mobile__toggle" @click.prevent="toggleNav">
            <z-icon width="36" height="36" name="menu" v-show="!isOpen"></z-icon>
            <z-icon width="30" height="30" name="close" v-show="isOpen"></z-icon>
        </a>
        <div
            v-show="isOpen"
            class="nav-mobile__container"
        >
            <div
                v-if="navigationStack.length > 0"
                class="nav-mobile__header container"
                @click.prevent="backToMain()"
            >
                <button class="nav-mobile__close">
                    <z-icon
                        name="round-arrow"
                        width="23"
                        height="23"
                        dir="left"
                    />
                    <span>{{ backLinkText }}</span>
                </button>
            </div>
            <div class="nav-mobile__body container">
                <p
                    v-if="currentNav && currentNav.name"
                    class="nav-mobile__title"
                >
                    {{ currentNav.name }}
                </p>
                <nav class="navigation-mobile__list">
                    <template
                        v-for="item in getCurrentMenuItems"
                    >
                        <component
                            v-if="!item.hide"
                            :is="isHasChildren(item) ? 'div' : 'z-link' "
                            :key="`${item.name}-${item.link}`"
                            :href="isHasChildren(item) ? null : item.link"
                            :class="{'is-active': checkActiveState(item) }"
                            class="nav-mobile__list-link"
                            theme="white"
                            @click="handleSubMenu(item)"
                        >
                            <span v-html="item.name" />
                            <span v-if="item.subtitle" class="nav-mobile__list-subtitle" v-html="item.subtitle" />
                            <z-icon
                                v-if="isHasChildren(item)"
                                width="20"
                                height="20"
                                name="round-arrow-folder/arrow"
                                dir="right"
                            />
                        </component>
                    </template>
                </nav>
            </div>
            <div class="nav-mobile__footer container">
                <div class="nav-mobile__footer-socials">
                    <z-link
                        href="https://www.youtube.com/user/NornikOfficial"
                        class="nav-mobile__footer-socials-icon"
                    >
                        <z-icon
                            name="youtube"
                            width="24"
                            height="24"
                        />
                    </z-link>
                    <z-link
                        href="https://vk.com/nornickel_official"
                        class="nav-mobile__footer-socials-icon nav-mobile__footer-socials-icon--vk"
                    >
                        <z-icon
                            name="vk"
                            width="24"
                            height="24"
                        />
                    </z-link>
                    <z-link
                        :href="
                                lang !== 'ru'
                                    ? 'https://www.nornickel.com/rss/'
                                    : 'https://www.nornickel.ru/rss/'
                            "
                        class="nav-mobile__footer-socials-icon"
                    >
                        <z-icon
                            name="rss"
                            width="24"
                            height="24"
                        />
                    </z-link>
                    <z-link
                        href="https://t.me/nornickel_official"
                        class="nav-mobile__footer-socials-icon"
                    >
                        <z-icon
                            name="telegram"
                            width="24"
                            height="24"
                        />
                    </z-link>
                    <z-link
                        href="https://ok.ru/group/55429567348892"
                        class="nav-mobile__footer-socials-icon nav-mobile__footer-socials-icon--ok"
                    >
                        <z-icon
                            name="Odnoklassniki"
                            width="24"
                            height="24"
                        />
                    </z-link>
                </div>
                <a v-if="lang === 'ru'" href="/other-sites/" class="nav-mobile__footer-button group-sites-button">
                    <span class="group-sites-button__button-text">Сайты группы</span>
                    <span class="group-sites-button__button-arrow">
                        <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 9L5 5L1 1" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                    </span>
                </a>
            </div>
        </div>
    </nav>
</template>

<script>
import { localize } from '@/utils/i18n'

export default {
    name: 'navigation-mobile',
    inject: ['isBlank'],
    data () {
        return {
            lang: this.$root?.app?.page?.lang,
            isOpen: false,
            currentNav: null,
            navigationStack: [],
            backLinkText: localize({
                ru: 'Назад',
                en: 'Back',
                cn: 'Back'
            })
        }
    },
    computed: {
        getCurrentMenuItems () {
            if (this.currentNav?.items && this.currentNav?.items.length > 0) {
                return this.currentNav.items
            }

            if (!this.currentNav) {
                return this.$root.app.components.navigation.top || null
            }

            return []
        }
    },
    methods: {
        toggleNav () {
            if (!this.isOpen) {
                this.setCurrentNav(this.$root.app.components.navigation.top)
                this.isOpen = true
                document.body.style.overflow = 'hidden'
                this.$root.$bus.$emit('navigation-open')
                document.querySelector('body').classList.add('nav-opened')
            } else {
                this.isOpen = false
                document.body.style.overflow = ''
                this.$root.$bus.$emit('navigation-close')
                document.querySelector('body').classList.remove('nav-opened')
            }
        },
        backToMain () {
            if (this.navigationStack.length > 0) {
                this.currentNav = this.navigationStack.pop()
            } else {
                this.isOpen = false
                this.navigationStack = []
                this.currentNav = null
            }
        },
        isHasChildren (item) {
            return item.items && item.items.length > 0
        },
        checkActiveState (item) {
            if (!item.link) return false

            const link = new URL(item.link, window.location.origin)

            if (link.hash) {
                this.isOpen = false
                document.body.style.overflow = ''
                this.$root.$bus.$emit('navigation-close')
                document.querySelector('body').classList.remove('nav-opened')
            }

            return item.active
        },
        handleSubMenu (navItem) {
            const link = new URL(navItem.link, window.location.origin)

            if (link.hash && !this.isHasChildren(navItem)) {
                document.querySelector('html').classList.remove('html--header-menu-opened')
                return
            }

            if (!this.isHasChildren(navItem)) return
            if (this.currentNav === navItem) return

            this.navigationStack.push(this.currentNav)
            this.currentNav = navItem
        },
        setCurrentNav (items) {
            if (!items || !items.length) return
            items.forEach(item => {
                if (item.active) {
                    if (!this.isHasChildren(item)) return
                    if (this.currentNav === item) return

                    this.navigationStack.push(this.currentNav)
                    this.currentNav = item

                    if (item.items && item.items.length > 0) {
                        this.setCurrentNav(item.items)
                    }
                }
            })
        }
    }
}
</script>

<style lang="scss" src="./index.scss"></style>
